/*

This might need just a bit of explanation here.  AuthState dictates what component is loading so to standardize
the routes between the routing module and the route manager; the paths are defined here

 */
export enum AuthState {
  INITIALIZING = 'loading',
  NO_ID = 'welcome',
  BAD_SUBSCRIPTION = 'bad-subscription',
  AUTHORIZED = 'dashboard',
  GATEWAY_ERROR = 'gateway-error',
}
